import cloneDeep from 'lodash.clonedeep';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import {
  Dispatch as StaffDispatch,
  GetState as StaffGetState,
} from 'redux/staff';

import {
  WorkHistoryJob,
  addWorkHistoryJob as apiAddWorkHistoryJob,
  deleteWorkHistoryJob as apiDeleteWorkHistoryJob,
  editWorkHistoryJob as apiEditWorkHistoryJob,
  fetchApplicantProfile as apiFetchApplicantProfile,
  updateApplicantProfile as apiUpdateApplicantProfile,
} from 'api/applicantProfile';
import {
  CurrentUser,
  SavedSearch,
  SavedSearchUnsaved,
  fetchCurrentUser as apiFetchCurrentUser,
  saveListing as apiSaveListing,
  saveSearch as apiSaveSearch,
  setABExperimentBucket as apiSetABExperimentBucket,
  unsaveListing as apiUnsaveListing,
  unsaveSearch as apiUnsaveSearch,
} from 'api/currentUser';
import { trackEvent } from 'utils/analytics';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { extractLocationProperties } from 'utils/getMainSearchTrackingData';
import { getItem, setItem } from 'utils/localStorage';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '..';
import { pushFlashMessage } from './flashMessages';

type FetchCurrentUserRequestAction = {
  type: 'CURRENT_USER_FETCH_REQUEST';
};
type FetchCurrentUserSuccessAction = {
  type: 'CURRENT_USER_FETCH_SUCCESS';
  currentUser: CurrentUser;
};
type UpdateCurrentUserWith = {
  type: 'CURRENT_USER_UPDATE_PARTIAL';
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUserPartial: Record<string, any>;
};
type UpdateSearchLocationAction = {
  type: 'CURRENT_USER_UPDATE_SEARCH_LOCATION';
  location: SearchLocation;
};
type ClearSearchLocationAction = {
  type: 'CURRENT_USER_CLEAR_SEARCH_LOCATION';
};
type SaveListingAction = {
  type: 'SAVE_LISTING';
  listingId: string;
  listingType: string;
};
type UnsaveListingAction = {
  type: 'UNSAVE_LISTING';
  listingId: string;
};
type SaveSearchAction = {
  type: 'SAVE_SEARCH';
  savedSearch: SavedSearch;
};
type UnsaveSearchAction = {
  type: 'UNSAVE_SEARCH';
  searchId: string;
};
type FetchApplicantRequestAction = {
  type: 'APPLICANT_PROFILE_FETCH_REQUEST';
};
type FetchApplicantSuccessAction = {
  type: 'APPLICANT_PROFILE_FETCH_SUCCESS';
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUserPartial: Record<string, any>;
};
type FetchApplicantFailureAction = {
  type: 'APPLICANT_PROFILE_FETCH_FAILURE';
};
export type Action =
  | FetchCurrentUserRequestAction
  | FetchCurrentUserSuccessAction
  | UpdateCurrentUserWith
  | UpdateSearchLocationAction
  | ClearSearchLocationAction
  | SaveListingAction
  | UnsaveListingAction
  | SaveSearchAction
  | UnsaveSearchAction
  | FetchApplicantRequestAction
  | FetchApplicantSuccessAction
  | FetchApplicantFailureAction;

const fetchCurrentUserRequest = (): FetchCurrentUserRequestAction => ({
  type: 'CURRENT_USER_FETCH_REQUEST',
});

const fetchCurrentUserSuccess = (
  currentUser: CurrentUser
): FetchCurrentUserSuccessAction => ({
  type: 'CURRENT_USER_FETCH_SUCCESS',
  currentUser,
});

export const fetchCurrentUser =
  () => (dispatch: Dispatch, getState: GetState) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring
    const currentUser = getState().currentUser;

    if (currentUser && currentUser.isFetching) {
      return Promise.resolve() as Promise<void>;
    }

    dispatch(fetchCurrentUserRequest());
    return apiFetchCurrentUser().then((fetchedUser) => {
      // Read searchLocation from localstorage
      // @TODO replace fallback to searchLocation with guessedLocation
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-param-reassign
      fetchedUser.searchLocation =
        getItem('searchLocation') || fetchedUser.searchLocation;
      dispatch(fetchCurrentUserSuccess(fetchedUser));
    });
  };
export const fetchCurrentUserForStaff =
  () => (dispatch: StaffDispatch, getState: StaffGetState) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring
    const currentUser = getState().currentUser;

    if (currentUser && currentUser.isFetching) {
      return Promise.resolve() as Promise<void>;
    }

    dispatch(fetchCurrentUserRequest());
    return apiFetchCurrentUser().then((fetchedUser) =>
      dispatch(fetchCurrentUserSuccess(fetchedUser))
    );
  };
export const updateCurrentUser = fetchCurrentUserSuccess;
export const updateCurrentUserWith = (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUserPartial: Record<string, any>
): UpdateCurrentUserWith => ({
  type: 'CURRENT_USER_UPDATE_PARTIAL',
  currentUserPartial,
});
export const updateSearchLocation =
  (location: SearchLocation, didUserChange: boolean) =>
  (dispatch: Dispatch) => {
    if (didUserChange) {
      trackEvent(
        'Changed Search Location',
        extractLocationProperties(location)
      );
    }

    return Promise.resolve()
      .then(() => setItem('searchLocation', location))
      .then(() =>
        dispatch({
          type: 'CURRENT_USER_UPDATE_SEARCH_LOCATION',
          location,
        })
      );
  };
const EVERYWHERE_LOCATION = {
  full: null,
  text: null,
  geoType: null,
  stateCode: null,
  countryCode: null,
  latitude: null,
  longitude: null,
  boundingBoxN: null,
  boundingBoxS: null,
  boundingBoxW: null,
  boundingBoxE: null,
};
export const clearSearchLocation =
  (didUserChange: boolean) => (dispatch: Dispatch) => {
    if (didUserChange) {
      trackEvent('Cleared Search Location');
    }

    return Promise.resolve()
      .then(() => setItem('searchLocation', EVERYWHERE_LOCATION))
      .then(() =>
        dispatch({
          type: 'CURRENT_USER_CLEAR_SEARCH_LOCATION',
        })
      );
  };
export const saveListing =
  (listingId: string, listingType: string, listingName: string) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: 'SAVE_LISTING',
      listingId,
      listingType,
    });

    if (listingType === 'ORG') {
      dispatch(
        pushFlashMessage({
          type: 'SAVE_ORG',
          data: {
            orgName: listingName,
          },
        })
      );
    } else if (listingType === 'GROUP') {
      dispatch(
        pushFlashMessage({
          type: 'SAVE_GROUP',
          data: {
            groupName: listingName,
          },
        })
      );
    }

    return apiSaveListing(listingId, listingType).catch((error) => {
      dispatch({
        type: 'UNSAVE_LISTING',
        listingId,
        listingType,
      });
      throw error;
    });
  };
export const unsaveListing =
  (listingId: string, listingType: string, listingName: string) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: 'UNSAVE_LISTING',
      listingId,
    });

    if (listingType === 'ORG') {
      dispatch(
        pushFlashMessage({
          type: 'UNSAVE_ORG',
          data: {
            orgName: listingName,
          },
        })
      );
    } else if (listingType === 'GROUP') {
      dispatch(
        pushFlashMessage({
          type: 'UNSAVE_GROUP',
          data: {
            groupName: listingName,
          },
        })
      );
    }

    return apiUnsaveListing(listingId, listingType).catch((error) => {
      // if listing was already removed, ignore error
      if (error.statusCode !== 404) {
        dispatch({
          type: 'SAVE_LISTING',
          listingId,
          listingType,
        });
        throw error;
      }
    });
  };
export const saveSearch =
  (search: SavedSearchUnsaved) => (dispatch: Dispatch) =>
    apiSaveSearch(search).then((savedSearch) => {
      dispatch({
        type: 'SAVE_SEARCH',
        savedSearch,
      });
      dispatch(
        pushFlashMessage({
          type: 'SAVED_SEARCH',
        })
      );
      trackEvent('Created Email Alert');
    });
export const unsaveSearch = (searchId: string) => (dispatch: Dispatch) =>
  apiUnsaveSearch(searchId).then(() => {
    dispatch({
      type: 'UNSAVE_SEARCH',
      searchId,
    });
    dispatch(
      pushFlashMessage({
        type: 'UNSAVED_SEARCH',
      })
    );
  });
export const setABExperimentBucket =
  (experimentId: string, bucket?: string) =>
  (dispatch: Dispatch, getState: GetState) => {
    const currentUser = cloneDeep(getState().currentUser);
    return apiSetABExperimentBucket(experimentId, bucket).then(
      (abExperiments) => {
        currentUser.abExperiments = abExperiments;
        dispatch(updateCurrentUser(currentUser));
        return abExperiments;
      }
    );
  };

const dispatchProfileUpdate = (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  request: (...args: Array<any>) => any,
  dispatch: Dispatch
) => {
  dispatch({
    type: 'APPLICANT_PROFILE_FETCH_REQUEST',
  });
  return request()
    .then((currentUserPartial) => {
      dispatch({
        type: 'APPLICANT_PROFILE_FETCH_SUCCESS',
        currentUserPartial,
      });
    })
    .catch((error) => {
      dispatch({
        type: 'APPLICANT_PROFILE_FETCH_FAILURE',
      });
      throw error;
    });
};

export const fetchApplicantProfile = () => (dispatch: Dispatch) =>
  dispatchProfileUpdate(() => apiFetchApplicantProfile(), dispatch);
export const updateApplicantProfile =
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (values: Record<string, any>) => (dispatch: Dispatch) =>
    dispatchProfileUpdate(() => apiUpdateApplicantProfile(values), dispatch);
export const updateWorkHistoryJob =
  (job: WorkHistoryJob, id: string | null | undefined) =>
  (dispatch: Dispatch) => {
    const submit = () =>
      id ? apiEditWorkHistoryJob(id, job) : apiAddWorkHistoryJob(job);

    return dispatchProfileUpdate(() => submit(), dispatch);
  };
export const deleteWorkHistoryJob = (id: string) => (dispatch: Dispatch) =>
  dispatchProfileUpdate(() => apiDeleteWorkHistoryJob(id), dispatch);
